export default function clearData (dispatch) {
  dispatch({type: 'pushData', value: {data: null, time: null, duration: null, project: {}, inspector: {}}})
}